import { render, staticRenderFns } from "./StepMultiTimeResourceCard.vue?vue&type=template&id=cb7832b6&scoped=true"
import script from "./StepMultiTimeResourceCard.vue?vue&type=script&lang=ts"
export * from "./StepMultiTimeResourceCard.vue?vue&type=script&lang=ts"
import style0 from "./StepMultiTimeResourceCard.vue?vue&type=style&index=0&id=cb7832b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7832b6",
  null
  
)

export default component.exports